
<br><br><br><br><br><br><br>

<div fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="login-card">
        <mat-card-header>
            <mat-card-title>Change Password</mat-card-title>
        </mat-card-header>
        <mat-card-content >
          
            <form fxLayout="column" action="" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit(changePasswordForm)">
              <div fxLayout="row">&nbsp;</div>

              <mat-form-field appearance="outline" fxFlex="100" fxLayout="column">
                    <mat-label>Current Password</mat-label>
                    <input   formControlName="password" matInput placeholder="Current Password" type="password">
                    <mat-error *ngIf="changePasswordForm.controls['password'].invalid && (changePasswordForm.controls['password'].dirty || changePasswordForm.controls['password'].touched)">Current Password field is Mandatory.</mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" fxFlex="100"  fxLayout="column">
                    <mat-label>New Password</mat-label>
                    <input formControlName="new_password" matInput placeholder="New Password" type="password">
                    <mat-error *ngIf="changePasswordForm.controls['new_password'].invalid && (changePasswordForm.controls['new_password'].dirty || changePasswordForm.controls['new_password'].touched)">New Password field is Mandatory.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="100"  fxLayout="column">
                    <mat-label>Confirm Password</mat-label>
                    <input formControlName="confirmPassword" matInput placeholder="Confirm Password" type="password">
                    <mat-error *ngIf="changePasswordForm.controls['confirmPassword'].errors?.['confirmedValidator']">Passwords didn't match.</mat-error>
                  </mat-form-field>
                  <div fxLayout="column" fxLayoutAlign="center end">
                  <button mat-raised-button color="primary" class="login-button" type="submit">Submit</button>
                </div>
                </form>
        </mat-card-content>
    </mat-card>
    </div>
    